export var LanguageCustomizationForm;
(function (LanguageCustomizationForm) {
    let Fields;
    (function (Fields) {
        Fields["subject"] = "subject";
        Fields["body"] = "body";
        Fields["ratingQuestion"] = "ratingQuestion";
        Fields["ratingStyle"] = "ratingStyle";
        Fields["headerText"] = "headerText";
        Fields["subheaderText"] = "subheaderText";
        Fields["placeholderText"] = "placeholderText";
        Fields["actionButtonText"] = "actionButtonText";
    })(Fields = LanguageCustomizationForm.Fields || (LanguageCustomizationForm.Fields = {}));
})(LanguageCustomizationForm || (LanguageCustomizationForm = {}));
